/* State Imports */

import StateInterface from "../state-interface";

/* Is Loading Default State Data */

export const notifications_loading: StateInterface["notifications_loading"] = {
  notifications: true,
};
